const metrics = [
  { icon: 'ri-fire-line', value: '+21%', label: 'продуктивность вовлечённых сотрудников' },
  { icon: 'ri-line-chart-line', value: '+25–30%', label: 'рост производительности команды' },
  { icon: 'ri-chat-check-line', value: 'Меньше', label: 'времени на согласования и разбор конфликтов' },
];

export default function EffectMetrics() {
  return (
    <section className="py-12 md:py-16 bg-gray-50 border-b border-gray-100">
      <div className="max-w-6xl mx-auto px-6">
        <h2 className="text-xl md:text-3xl font-bold text-gray-900 text-center mb-3">
          Эффект развития Soft Skills в цифрах
        </h2>
        <p className="text-sm md:text-base text-gray-600 text-center max-w-3xl mx-auto mb-10 leading-relaxed">
          Мягкие навыки сложно увидеть напрямую, но их влияние отражается на вовлечённости, скорости работы и атмосфере в команде.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6">
          {metrics.map((m) => (
            <div key={m.label} className="bg-white rounded-xl border border-gray-200 p-6 text-center">
              <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className={`${m.icon} text-xl text-teal-700`}></i>
              </div>
              <div className="text-3xl md:text-4xl font-extrabold text-teal-600 mb-1">{m.value}</div>
              <div className="text-xs md:text-sm text-gray-600 leading-relaxed">{m.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}